/*
 * This component displays a table of contacts with options to edit or delete each contact.
 * It receives a list of contacts and optional callback functions for editing and deleting contacts.
 */

import React from 'react';
import { ContactData } from '../types/types';
import { MainButton, DeleteButton } from '../../../common';

// Props for the ContactsTable component
interface ContactsTableProps {
	contacts: ContactData[];
	onEdit: (id: number) => void;
	onDelete: (id: number) => void;
}

// ContactsTable component
const ContactsTable: React.FC<ContactsTableProps> = ({
	contacts,
	onEdit,
	onDelete,
}) => {
	if (contacts.length === 0) {
		return <p>Aucun contact trouvé.</p>;
	}

	// Render the contacts table
	return (
		<div className="overflow-x-auto">
			{/* Table structure with headers and rows for each contact */}
			<table className="min-w-full border border-gray-200 rounded-lg">
				{/* Table headers */}
				<thead className="bg-gray-50">
					<tr>
						<th className="px-6 py-3 text-left text-gray-400 font-medium border-b">
							ID
						</th>
						<th className="px-6 py-3 text-left text-gray-700 font-medium border-b">
							Prénom
						</th>
						<th className="px-6 py-3 text-left text-gray-700 font-medium border-b">
							Nom
						</th>
						<th className="px-6 py-3 text-left text-gray-700 font-medium border-b">
							Actions
						</th>
					</tr>
				</thead>
				{/* Table body */}
				<tbody className="bg-white divide-y divide-gray-200">
					{contacts.map((contact) => (
						<tr key={contact.id}>
							<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
								{contact.id}
							</td>
							<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
								{contact.firstName}
							</td>
							<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
								{contact.lastName}
							</td>
							<td className="px-6 py-4 border-b space-x-2">
								<div className="flex space-x-2">
									{onEdit && (
										<MainButton
											label="Éditer"
											onClick={() => onEdit(contact.id)}
											size="md"
										/>
									)}
									{onDelete && (
										<DeleteButton
											question={`Voulez-vous vraiment supprimer le contact ${contact.firstName} ${contact.lastName} ?`}
											onConfirm={() => onDelete(contact.id)}
											size="md"
										/>
									)}
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default ContactsTable;
